import { useEffect, useState } from 'react'
import { Formik, Form } from 'formik'
import * as Analytics from 'core/common/analytics'
import i18n from 'core/common/i18n'
import { Card, CardContent, Button, Typography, Link } from 'core/components/Core'
import ProductName from 'core/containers/ProductDescription/components/ProductName'
import ProductRelevanceCallout from 'core/containers/ProductRelevanceCallout'
// import { useAppContext } from 'core/pages/ProductNew-v2/context/AppContext'
import { useFormContext } from 'core/pages/ProductNew-v2/context/ProductNewContext'
import ProductDialogTitleTips from './components/ProductDialogTitleTips'
import { getBasicDataSchema } from './schema'

export const ProductBasicDataForm = ({
  onNext,
  isEditMode,
  onEditSubmit,
  custom,
  handleEditStep,
  step,
  formMode,
}) => {
  const [open, setOpen] = useState(false)
  const [isSubmitting, setIsSubmitting] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const { formData, setFormData } = useFormContext()
  const initialValues = { name: formData.name || '' }

  useEffect(() => {
    const submitEdit = async () => {
      if (isSubmitting && isEditMode && onEditSubmit) {
        setIsSubmitting(false)
        setIsLoading(true)
        try {
          await onEditSubmit(formData)
          setIsLoading(false)
        } catch (error) {
          console.error('Error during API call', error)
        } finally {
          setIsLoading(false)
        }
      }
    }

    submitEdit()
  }, [isSubmitting, formData, isEditMode, onEditSubmit])

  const onSubmit = async values => {
    Analytics.ProductTitleSaved(formMode)
    setFormData(prevData => ({ ...prevData, name: values.name.trim() }))

    setIsSubmitting(true)
    onNext()
  }

  const handleValidation = async ({ validateForm }) => {
    const errors = await validateForm()

    if (errors.name) {
      Analytics.ProductTitleValidationError(formMode)
    }
  }

  return (
    <Formik
      initialValues={initialValues}
      onSubmit={onSubmit}
      validationSchema={getBasicDataSchema(custom?.maxLimit)}
      enableReinitialize
    >
      {({ handleSubmit, dirty, resetForm, validateForm }) => {
        return (
          <Form className="w-100">
            <div className="mb-8">{custom?.confirmation}</div>

            <Card raised elevation={1} className="p-4">
              <CardContent className="p-0">
                {!isEditMode && (
                  <Typography variant="h5" component="h2" className="mb-4">
                    {i18n.t('productNew.basicData.offerTitle')}
                  </Typography>
                )}
                {custom?.link ? (
                  custom?.link
                ) : (
                  <Typography variant="body1" color="secondary" className="mb-4">
                    {i18n.t('productNew.basicData.titleTips')}{' '}
                    <Link variant="link" onClick={() => setOpen(true)} className="cursor-pointer">
                      {i18n.t('productNew.basicData.titleTipsLink')}
                    </Link>
                  </Typography>
                )}

                <ProductRelevanceCallout
                  disableScoreInfo={custom?.disableScoreInfo}
                  recommendations={[i18n.t('productNew.basicData.relevanceRecommendation')]}
                  onClick={() => {
                    Analytics.ProductBasicDataRelevanceClicked(formMode)
                  }}
                />

                <ProductName
                  placeholder={i18n.t('productNew.basicData.productNamePlaceholder')}
                  textLimit={custom?.maxLimit}
                  showWordLimit
                  className="mb-4"
                  onChange={() => handleEditStep(step.key)}
                />

                <div className="w-100 d-flex justify-end">
                  {!isEditMode && (
                    <>
                      <Button
                        variant="text"
                        color="primary"
                        onClick={() => {
                          resetForm()
                          handleEditStep(null)
                        }}
                        className="mr-2"
                      >
                        <span>Cancelar</span>
                      </Button>

                      <Button
                        variant="contained"
                        color="primary"
                        onClick={() => {
                          handleSubmit()
                          handleValidation({ validateForm })
                        }}
                      >
                        {i18n.t('productNew.actions.continue')}
                      </Button>
                    </>
                  )}

                  {isEditMode && (dirty || isLoading) && (
                    <>
                      <Button
                        variant="text"
                        color="primary"
                        onClick={() => resetForm()}
                        className="mr-2"
                      >
                        <span>Cancelar</span>
                      </Button>
                      <Button
                        variant="contained"
                        color="primary"
                        onClick={() => {
                          handleSubmit()
                          handleValidation({ validateForm })
                        }}
                        loading={isLoading}
                      >
                        <span>Salvar</span>
                      </Button>
                    </>
                  )}
                </div>

                <ProductDialogTitleTips open={open} onClose={() => setOpen(false)} />
              </CardContent>
            </Card>
          </Form>
        )
      }}
    </Formik>
  )
}
